import { AxiosInstance } from 'axios'
import { mountWidget, webchat } from '@/types/mountWidget'
import { RequestError } from '@/types/error'
import state from '@/store'
import { setMessages, upMessage } from '@/store/messages'
import { MessageChat } from '@/types/message'
import websocket from '@/services/websocket'
import useChat from '@/hooks/useChat'

type UploadFile = {
  data: string | null
  errors: RequestError | null
}

type UrlFile = {
  data: string
}

type Create = {
  token: string
  user: string
  errors: RequestError | null
}

type Mount = {
  data: webchat
  errors: RequestError | null
}

type CreatePayload = {
  name: string
  email: string
  channel?: number
  device: string
  page: string
  apiKey: string
}

type FecthPayload = {
  user: string | null
  device: string
  page: string
  apiKey: string
  email?: string
  custom_token?: string
  name?: string
}

export interface WebchatServiceInterface {
    mount (payload: FecthPayload): Promise<Mount>
    start (payload: CreatePayload): Promise<Create>
    upload (payload: FormData): Promise<UploadFile>
    fetchMessages (): Promise<void>
    formSendMessage (payload: MessageChat): Promise<void>
}

function WebchatService (httpClient: AxiosInstance): WebchatServiceInterface {
    async function mount (payload: FecthPayload): Promise<Mount> {
        const response = await httpClient.post<mountWidget>('/webchat/mount', payload)
        let errors: RequestError | null = null

        if (!response?.data) {
            const responseRequest = JSON.parse(response.request.response)
            errors = {
                ...responseRequest,
                status: response.request.status,
                statusText: response.request.statusText
            }
        }

        return {
          data: response?.data?.data ?? null,
          errors
        }
    }

    async function start (payload: CreatePayload): Promise<Create> {
        const response = await httpClient.post('/webchat/start', payload)
        let errors: RequestError | null = null

        if (!response.data) {
            const responseRequest = JSON.parse(response.request.response)
            errors = {
                ...responseRequest,
                status: response.request.status,
                statusText: response.request.statusText
            }
        }

        return {
            token: response?.data?.token ?? null,
            user: response?.data?.user ?? null,
            errors
        }
    }
    /**
     * Upload file webchat
    */
    async function upload (payload: FormData): Promise<UploadFile> {
        const config = { headers: { 'content-type': 'multipart/form-data' } }
        const response = await httpClient.post<UrlFile>('/webchat/upload', payload, config)

        let errors: RequestError | null = null

        if (!response.data) {
            errors = {
                status: response.request.status,
                statusText: response.request.statusText
            }
        }

        return {
            data: response?.data?.data ?? null,
            errors
        }
    }

    /**
     * Fetch messages webchat
    */
    async function fetchMessages (): Promise<void> {
        httpClient.get(`${state.urlBase}/webchat/attendances/${state.attendance.id}/messages`)
        .then((response) => {
            // eslint-disable-next-line
            const messages = response.data.data.map((message: any) => {
            message.type = message.type === 'received' ? 'sent' : 'received'
            return message
            })
            setMessages(messages)
        })
        .catch(() => {
            const { startChat } = useChat()
            const startMessage = document.querySelector('.message_system')
            if (!startMessage) setTimeout(() => startChat(), 1000)
        })
    }

  async function formSendMessage (payload: MessageChat): Promise<void> {
    const sendWS = {
      ...payload,
      api_id: state.apiId,
      client: {
        user: state.user,
        name: state.name
      }
    }
    websocket.sendMessageWebchat('send_message', sendWS, [])
    upMessage(payload)
  }

  return {
    start,
    mount,
    upload,
    fetchMessages,
    formSendMessage
  }
}

export default WebchatService
